function upsell() {
    UPSELL = [];    
    CANVAS_COUNT = 0;

    function init(pCart) {       
        UPSELL = [];
        CANVAS_COUNT = 0;

        $('#lm-multi-upsell ul.products li').addClass('show');
        for (var i = 0; i < pCart.items.length; i++) {
            var sku = pCart.items[i].sku;
            if(sku.includes('GREETINGCARD')) {
              sku = 'GREETINGCARD';
            }                 
            $('#lm-multi-upsell ul.products li[data-product-sku^="' + sku + '"]').removeClass('show');
          
            if (pCart.items[i].product_type.includes('Leinwand')) {
                CANVAS_COUNT += pCart.items[i].quantity;
            }
        }
        $('#lm-multi-upsell .content .amount select').each(function() {
          var html = "";
          for(var i=0; i < 5; i++) {
            html += "<option data-value='" + (i+1) + "'>" + (i+1) + "x</option>";
          }
          $(this).html(html);          
        });

        //preselection
        /*for (var i = 0; i < pCart.items.length; i++) {          
            $('#lm-multi-upsell li[data-product-sku="' + pCart.items[i].sku + '"]').addClass('active');
            $('#lm-multi-upsell li[data-product-sku="' + pCart.items[i].sku + '"] .amount option[data-value="' + pCart.items[i].quantity + '"]').attr('selected','selected');    
            $('#lm-multi-upsell li[data-product-sku="' + pCart.items[i].sku + '"] .amount').addClass('active');         
        }*/      
        
    }
  
    theme.cart.getCart().then(init);
    $('body').on('added.ajaxProduct', function(evt, returnFocusEl) {
        theme.cart.getCart().then(init);
    });
    /**************************************/
    /****** SHOW UPSELL
    /**************************************/
    $(document).on('click', '.cart__checkout, .lm-go-checkout', function() {
        var _this = this;
        $(_this).addClass('btn--loading');
        setTimeout(function() {
            $(_this).removeClass('btn--loading');
        }, 3 * 1000);
        if($('#lm-multi-upsell ul.products li.show').length == 0) {
          return true;
        }
        $('#lm-multi-upsell #lm-upsell-add').text($('#lm-multi-upsell #lm-upsell-add').attr('data-text0')).removeClass('btn--loading');
        $('#lm-multi-upsell ul.products li').removeClass('active');
        $('#lm-multi-upsell li .amount').removeClass('active');
        $('#lm-multi-upsell li .amount option').first().prop('selected', 'selected');
        UPSELL = [];
        $('#lm-multi-upsell').css('visibility', 'visible').hide().fadeIn(250);
        $('body').addClass('lm-fixed');
        return false;
    });

    window.addEventListener('popstate', (event) => {
        $('.btn[name="checkout"]').removeClass('btn--loading');
        $('body').removeClass('lm-fixed');
        $('#lm-multi-upsell').fadeOut(0);
    });

    /**************************************/
    /****** CLOSE UPSELL
    /**************************************/
    $(document).on('click', '#lm-multi-upsell .lm-multi-upsell-close', closeMultiUpsell);

    /**************************************/
    /****** ACTION BUTTONS
    /**************************************/
    $(document).on('click', '#lm-multi-upsell .discard', function() {
        $('#lm-multi-upsell .content.page2').fadeOut(0);
        $('#lm-multi-upsell .content.page1').fadeIn(0);
        e.preventDefault();
        return false;
    });
    $(document).on('click', '#lm-multi-upsell .content.page2 i.fa-chevron-left', function() {
        $('#lm-multi-upsell .content.page2').fadeOut(0);
        $('#lm-multi-upsell .content.page1').fadeIn(0);
        //$('.lm-greetingcard .variant-selection span').first().click();
        //$('.lm-greetingcard .message textarea').val('').removeClass('filled');
    });
    $(document).on('click', '#lm-multi-upsell ul.products li select', function(e) {
        e.preventDefault();
        return false;
    });
     $(document).on('change', '#lm-multi-upsell ul.products li select', function(e) {
       var quantity = parseInt($(this).find(":selected").val().replace('x', ''));
       var newPriceElement = $(this).parent().parent().find('.new-price');
       var oldPriceElement = $(this).parent().parent().find('.old-price');
       var price = newPriceElement.attr('data-price');
       var oldPrice = oldPriceElement.attr('data-regular-price');
       price = price * quantity;
       oldPrice = oldPrice * quantity;
       newPriceElement.text(theme.Currency.formatMoney(price, theme.settings.moneyFormat));
       oldPriceElement.text(theme.Currency.formatMoney(oldPrice, theme.settings.moneyFormat));
      
    });
    $(document).on('click', '#lm-multi-upsell .lm-greetingcard .save', function(e) {
        var params = {};
        var values = {
            "motiv": $('.lm-greetingcard .variant-selection span.active').attr('data-key').toLowerCase(),
            "text": $('.lm-greetingcard textarea').val()
        };
        var variantID = $('.lm-greetingcard .variant-selection span.active').attr('data-variant-id');
        var productHandle = $('.lm-greetingcard').attr('data-product-handle');
        params['Text'] = $('.lm-greetingcard textarea').val();
        params['_lm-customizer0'] = "https://backend.leinwandmomente.de/de/display/8540628058376?type=card1&" + new URLSearchParams(values).toString();
        params['_preview-url'] = "https://backend.leinwandmomente.de/de/display/8540628058376?type=[type]&" + new URLSearchParams(values).toString();
        params['_edit-url'] = window.location.origin + '/products/' + productHandle + "?variant=" +  variantID + "&lm&" + new URLSearchParams(values).toString();

        UPSELL.push({
            'id': variantID,
            'quantity': 1,
            'properties': params
        });

        $('#lm-multi-upsell #lm-upsell-add').text($('#lm-multi-upsell #lm-upsell-add').attr('data-text1'));
        $('#lm-multi-upsell li[data-product-sku*="GREETINGCARD-"] .amount').addClass('active');
        
        $('#lm-multi-upsell li[data-product-sku*="GREETINGCARD-"] .half-info.image img').attr('srcset', params['_lm-customizer0']);
        $('#lm-multi-upsell li[data-product-sku*="GREETINGCARD-"]').addClass('active');
        $('.lm-greetingcard .variant-selection span').first().click();
        $('.lm-greetingcard .message textarea').val('').removeClass('filled');
        $('#lm-multi-upsell .content.page2').fadeOut(0);
        $('#lm-multi-upsell .content.page1').fadeIn(0);

        e.preventDefault();
        return false;
    });
    /**************************************/
    /****** ADD ITEM
    /**************************************/
    $(document).on('click', '#lm-multi-upsell ul.products li', function() {
        var variantID = $(this).attr('data-variant-id');
        var productSKU = $(this).attr('data-product-sku');
        if ($(this).hasClass('active')) {
            $(this).removeClass('active');
            $(this).find('img').attr('srcset', $(this).find('img').attr('data-init-src'));
            $(this).find('.amount').removeClass('active');
            for (var i = 0; i < UPSELL.length; i++) {
                if (UPSELL[i]['id'] == variantID) {
                    UPSELL.splice(i, 1);
                    break;
                }
            }
        } else {
            if (productSKU.includes('GREETINGCARD')) {
                $('#lm-multi-upsell .content.page1').fadeOut(0);
                $('#lm-multi-upsell .content.page2').fadeIn(0);
            } else {
                $(this).addClass('active');
                $('#lm-multi-upsell #lm-upsell-add').text($('#lm-multi-upsell #lm-upsell-add').attr('data-text1'));
                UPSELL.push({
                    'id': variantID,
                    'quantity': 1
                });                
                $(this).find('.amount').addClass('active');                
            }
            
        }
    });
    $(document).on("change", "#lm-multi-upsell ul.products li .amount", function() {
        var variantID = $(this).parents('li').attr('data-variant-id');
        var quantity = parseInt($(this).find('option:selected').val().replace('x', ''));
        for (var i = 0; i < UPSELL.length; i++) {
            if (UPSELL[i]['id'] == variantID) {
                UPSELL[i]['quantity'] = quantity;
                break;
            }
        }

    });
    /**************************************/
    /****** SAVE
    /**************************************/
    $(document).on('click', '#lm-multi-upsell #lm-upsell-add', function() {
        var _this = this;
        $(_this).addClass('btn--loading');
        if (UPSELL.length == 0) {
            return closeMultiUpsell();
        }        
        $.ajax({
            type: 'POST',
            url: '/cart/add.js',
            data: {
                items: UPSELL,
            },
            dataType: 'json',
            success: function(data) {
                $('body').trigger('added.ajaxProduct', false); 
                
                closeMultiUpsell();
            },
            error: function(data) {
                $(_this).removeClass('btn--loading');
                console.log(data);
            },
        });
    });

    function closeMultiUpsell() {
        $('#lm-multi-upsell').fadeOut(500);
        window.location.href = '/checkout';        
    }
}

upsell();